import React from 'react';

import sAction from 'sAction';
import GlobalSearchListContainerDefault from 'ROOT/src/components/globalSearch/GlobalSearchListContainer';
import ListViewTable2 from '../list/listViewTable2';

class GlobalSearchListContainer extends GlobalSearchListContainerDefault {
    render() {
        const list = this.props.data;
        const way = this.props.way;
        const ind = this.props.ind;

        return (
            <div className="globalSearchListContainer"
                ref={this.listView}
                key={ind}>
                <div className="moduleTitle">{sAction.translate('LBL_MODULE_NAME', list.modul)}</div>
                <ListViewTable2 data={list} parent={this} prefix={way+'/results/'+ind} />
            </div>
        );
    }
}

export default GlobalSearchListContainer;
